// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.selected {
  border: 3px solid #007aa3 !important;
  opacity: 1 !important;
  filter: grayscale(0) !important;
}
.select-item {
  border: 3px solid transparent;
  opacity: 0.9;
  filter: grayscale(1);
}
.empty-message {
  font-size: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 10px;
  border-radius: 5px;
  color: dimgray;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/farmer-building/farmer-building.ts"],"names":[],"mappings":";;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["\n\n.selected {\n  border: 3px solid #007aa3 !important;\n  opacity: 1 !important;\n  filter: grayscale(0) !important;\n}\n.select-item {\n  border: 3px solid transparent;\n  opacity: 0.9;\n  filter: grayscale(1);\n}\n.empty-message {\n  font-size: 20px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 10px;\n  border-radius: 5px;\n  color: dimgray;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
